export default function NotFound() {
  return (
    <div className={"pad-1"} style={{fontSize:"2rem"}}>
      Az oldal nem található,<br/>vagy feltöltés alatt van.
    </div>
  )
}